import * as React from 'react'
import { Dialog, Tooltip } from '@mui/material'
import { AddRounded, CloseRounded, DeleteOutline, EditOutlined, LockOutlined } from '@mui/icons-material'
import { useDispatch } from '../../store'
import { deleteTicketType, fetchTicketTypes } from '../../store/support/actionCreator'
import { TicketType } from '../../store/support/reducer'
import { PopupTicketTypeCRUD } from '../../container/support/PopupTicketTypeCRUD'
import { ConfirmV2 } from '../ConfirmV2'
import { typeColor } from './supportTickets'
import l from '../../page/SubscribersPageV2.module.css'
import s from './SupportV2.module.css'

/*
 * Ticket types — what the classic popup kept inside its Type select: add,
 * edit and delete, with the three built-in types (general, technical,
 * financial) locked. The add / edit form is the classic one.
 */

const LOCKED = ['general', 'technical', 'financial']

export function TicketTypesDialogV2({ types, counts, theme, onClose }: {
  types: TicketType[]; counts: Record<number, number>; theme: string; onClose: () => void
}) {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState<{ mode: 'create' | 'edit'; data?: TicketType } | null>(null)
  const [toDelete, setToDelete] = React.useState<TicketType | null>(null)
  const refresh = () => dispatch(fetchTicketTypes)

  return (
    <>
      <Dialog open onClose={onClose} maxWidth={false} PaperProps={{ sx: { background: 'transparent', boxShadow: 'none', m: 2 } }}>
        <div className={`${l.theme} ${s.typesShell}`} data-theme={theme}>
          <div className={s.typesTop}>
            <b>Ticket types</b>
            <button type="button" className={s.iconGhost} onClick={onClose} aria-label="Close"><CloseRounded sx={{ fontSize: 18 }} /></button>
          </div>
          <div className={s.typesList}>
            {types.map((x) => {
              const locked = LOCKED.includes(x.name.toLowerCase())
              return (
                <div key={x.id} className={s.typeRow}>
                  <i style={{ background: typeColor(x.color) }} />
                  <b>{x.name}</b>
                  <span>{counts[x.id] || 0} tickets</span>
                  {locked ? (
                    <Tooltip title="Built-in — cannot be changed"><span className={s.lockIcon}><LockOutlined sx={{ fontSize: 15 }} /></span></Tooltip>
                  ) : (
                    <>
                      <Tooltip title="Edit"><button type="button" className={s.iconGhost} onClick={() => setForm({ mode: 'edit', data: x })} aria-label="Edit"><EditOutlined sx={{ fontSize: 16 }} /></button></Tooltip>
                      <Tooltip title="Delete"><button type="button" className={s.iconDanger} onClick={() => setToDelete(x)} aria-label="Delete"><DeleteOutline sx={{ fontSize: 16 }} /></button></Tooltip>
                    </>
                  )}
                </div>
              )
            })}
          </div>
          <div className={s.typesFoot}>
            <button type="button" className={s.primary} onClick={() => setForm({ mode: 'create' })}><AddRounded sx={{ fontSize: 17 }} />New type</button>
          </div>
        </div>
      </Dialog>
      {form && <PopupTicketTypeCRUD mode={form.mode} data={form.data} onSubmit={refresh} onClose={() => setForm(null)} />}
      {toDelete && (
        <ConfirmV2
          header={`Delete the type “${toDelete.name}”?${counts[toDelete.id] ? ` ${counts[toDelete.id]} tickets use it.` : ''}`}
          onYes={() => dispatch(deleteTicketType(toDelete.id, refresh))}
          onClose={() => setToDelete(null)}
        />
      )}
    </>
  )
}
